import { Difficulty } from '@gdladder/shared/enums';

export enum DemonLogoSizes {
    TINY = 32,
    SMALL = 64,
    MEDIUM = 128,
    LARGE = 160,
    EXTRA_LARGE = 190,
}

export function difficultyToImgSrc(diff?: Difficulty | number, size: DemonLogoSizes = DemonLogoSizes.EXTRA_LARGE) {
    switch (diff) {
        case Difficulty.EASY:
        case 1:
            return `/images/demon_logos/easy_${size}.webp`;
        case Difficulty.MEDIUM:
        case 2:
            return `/images/demon_logos/medium_${size}.webp`;
        case Difficulty.OFFICIAL:
        case Difficulty.HARD:
        default:
        case 3:
            return `/images/demon_logos/hard_${size}.webp`;
        case Difficulty.INSANE:
        case 4:
            return `/images/demon_logos/insane_${size}.webp`;
        case Difficulty.EXTREME:
        case 5:
            return `/images/demon_logos/extreme_${size}.webp`;
    }
}
